import styled from "styled-components";

const P = styled.p`
  padding: 0;
  margin: 0 0 15px;
`;
export const StyledDescription = styled(P)`
  padding-top: 30px;
  padding-bottom: 30px;
  font-family: "Negara";
  font-weight: 800;
  padding-left: 15px;
  padding-right:  15px;
  font-size:1em;
  text-indent: 50px;
  position: relative;
  color: #d8d9d9!important;
  line-height: 1.55;

  //background: rgba(255, 255, 255, 0.77);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4.4px);
  -webkit-backdrop-filter: blur(4.4px);
  //border: 1px solid #ffcc00

`;
